import React from "react";
import { IPlaylistResponseDto } from "../../../types";
import * as Styled from "./Playlist.styled";
import { playlistsService } from "../../../services";
import { MediaCollection } from "../../media-collection";

export const Playlist: React.FC<{
    playlist: IPlaylistResponseDto;
    clientId: string;
    enableRatingControls: boolean;
    sessionToken: string;
    isSignedIn: boolean;
    mediaPerPage: number;
    enableAutoplay: boolean;
}> = ({
    playlist,
    clientId,
    enableRatingControls,
    sessionToken,
    isSignedIn,
    mediaPerPage,
    enableAutoplay,
}) => {
        const [allMediaItems, setAllMediaItems] = React.useState(playlist.mediaItems);
        const [showLoader, setShowLoader] = React.useState(false);

        React.useEffect(() => {
            if (playlist.length > playlist.mediaItems.length) {
                setShowLoader(true);
                playlistsService.getPlaylistById(playlist.clientId, playlist.playlistId)
                    .then((resp) => setAllMediaItems(resp.mediaItems))
                    .finally(() => setShowLoader(false));
            }
        }, [playlist]);

        return (
            <Styled.PlaylistContainer>
                <MediaCollection
                    existingMedia={allMediaItems}
                    clientId={clientId}
                    fetchByDate="false"
                    enableFilterControls={false}
                    enableRatingControls={enableRatingControls}
                    enableShareControls={false}
                    sessionToken={sessionToken}
                    isSignedIn={isSignedIn}
                    mediaPerPage={mediaPerPage}
                    externalLoader={showLoader}
                    playlist={playlist}
                    enableAutoplay={enableAutoplay}
                />
            </Styled.PlaylistContainer>
        );
    };
